

import { useState } from 'react';

const useSelectContato = (type) => {
  const [values, setValues] = useState({}); 
  const [errors, setErrors] = useState({}); 


  function validate(index) {
    const value = values[index] || '';
    if (value === '') {
      const errorMsg = type == 'uf' ?  'Preencha o uf':'Preencha o campo corretamente!';
      setErrors((prev) => ({ ...prev, [index]: errorMsg }));
      return false;
    } else {
      setErrors((prev) => ({ ...prev, [index]: null }));
      return true;
    }
  }

  function clearField(index) {
    setValues((prev) => ({ ...prev, [index]: undefined }));
    setErrors((prev) => ({ ...prev, [index]: null }));
  }

  function upDateValue(index, value) {
    setValues((prev) => ({ ...prev, [index]: value }));
  }

  function upDateDefaultValue(index, value) {
    setValues((prev) => ({ ...prev, [index]: value }));
  }

  return {
    value: (index) => values[index] || '',
    error: (index) => errors[index],
    validate: (index) => validate(index),
    upDateValue: (index, value) => upDateValue(index, value),
    upDateDefaultValue: (index, value) => upDateDefaultValue(index, value),
    clearField: (index) => clearField(index),
  };
};

export default useSelectContato;
